import { createContext, useContext } from 'react';

export const ListNavigationContext = createContext(null);

export function useListNavigationContext() {
    return useContext(ListNavigationContext);
}

export function ListNavigationProvider({ value, children }) {
    return (
        <ListNavigationContext.Provider value={value}>
            {children}
        </ListNavigationContext.Provider>
    );
}
